
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'

class ReservaSala implements IReservaSala {
  async getReservaSalas(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getReservaSalas(params)
    return response
  }

  async sendReservaSalas(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.sendReservaSalas(params)
    return response
  }

  async getDoctorRoomReservations(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getDoctorRoomReservations(params)
    return response
  }

  async getRoomAvailabilityCalendar(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getRoomAvailabilityCalendar(params)
    return response
  }

  async getRoomConfigurationBySurgeryCenterAndHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getRoomConfigurationBySurgeryCenterAndHospital(params)
    return response
  }

  async updateRoomAvailabilityCalendar(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateRoomAvailabilityCalendar(params)
    return response
  }

  async getRoomStatusBySurgeryCenterAndHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getRoomStatusBySurgeryCenterAndHospital(params)
    return response
  }

  async updateRoomStatusSurgeryCenter(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateRoomStatusSurgeryCenter(params)
    return response
  }

  async deleteRoomAvailability(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.deleteRoomAvailability(params)
    return response
  }


  async getRoomShiftConfigurationBySurgeryCenterAndHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getRoomShiftConfigurationBySurgeryCenterAndHospital(params)
    return response
  }

  async updateShiftConfiguration(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateShiftConfiguration(params)
    return response
  }

  async updateRoomConfiguration(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateRoomConfiguration(params)
    return response
  }

  async updateReservationLimitDate(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateReservationLimitDate(params)
    return response
  }
}

interface IReservaSala {
  getReservaSalas(params: any): Promise<ResponseApi>
  sendReservaSalas(param: any): Promise<ResponseApi>
  getDoctorRoomReservations(param: any): Promise<ResponseApi>
  getRoomConfigurationBySurgeryCenterAndHospital(param: any): Promise<ResponseApi>
  updateRoomStatusSurgeryCenter(param: any): Promise<ResponseApi>
  getRoomStatusBySurgeryCenterAndHospital(param: any): Promise<ResponseApi>
  getRoomShiftConfigurationBySurgeryCenterAndHospital(param: any): Promise<ResponseApi>
  updateShiftConfiguration(param: any): Promise<ResponseApi>
  updateRoomConfiguration(param: any): Promise<ResponseApi>
  deleteRoomAvailability(param: any): Promise<ResponseApi>
  getRoomAvailabilityCalendar(param: any): Promise<ResponseApi>
  updateRoomAvailabilityCalendar(param: any): Promise<ResponseApi>
  updateReservationLimitDate(param: any): Promise<ResponseApi>
}

export {
  IReservaSala,
  ReservaSala,
}
